import { BaseService, Service } from "/@/cool";

interface ReportQuery {
	page?: number;
	size?: number;
	shop_id?: number;
	tag_ids?: number[];
	product_type?: number;
	order_create_start?: string;
	order_create_end?: string;
	tag_at_start?: string;
	tag_at_end?: string;
	key_word?: string;
	is_export?: number;
}

@Service("repairOrderTag")
class RepairOrderTag extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["tagOptions"] = prefix + "tagOptions";
		this.permission["current"] = prefix + "current";
		this.permission["save"] = prefix + "save";
		this.permission["reportPage"] = prefix + "reportPage";
		this.permission["reportExport"] = prefix + "reportExport";
	}

	// 获取标签列表
	tagOptions() {
		return this.request({
			url: "/tagOptions",
			method: "POST"
		});
	}

	// 获取当前有效标签（回显）
	current(data: { repair_id: number }) {
		return this.request({
			url: "/current",
			method: "POST",
			data
		});
	}

	// 保存打标
	save(data: {
		repair_id: number;
		order_id: number;
		tag_ids: number[];
		source: number;
	}) {
		return this.request({
			url: "/save",
			method: "POST",
			data
		});
	}

	// 打标报表分页
	reportPage(data: ReportQuery) {
		return this.request({
			url: "/reportPage",
			method: "POST",
			data
		});
	}

	// 打标报表导出
	reportExport(data: ReportQuery) {
		return this.request({
			url: "/reportExport",
			method: "POST",
			data
		});
	}
}

export default RepairOrderTag;
